import { useMemo } from 'react';

import { useSelector, useDispatch } from '@store/configureStore';
import { setPage, selectNav } from '@store/slices/nav.slice';

const useNavHook = () => {
  const dispatch = useDispatch();
  const { app, page, subPage } = useSelector(selectNav);

  return useMemo(
    () => ({
      setPage: page => {
        dispatch(setPage({ page }));
      },
      page,
    }),
    [app, page, subPage, dispatch]
  );
};

export default useNavHook;
